/***********************
 * INDEX TAB9 CONTENT
 * (GROUPVIDEOLICENSES)
 ************************/

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Col, Row } from "reactstrap"

// Locale
import { withTranslation } from "react-i18next"

// Importing components
import TableGroupLicenses from "./GroupLicensesTable"
import ChartLicenses from "./GroupLicensesChart"

const GroupVideoLicensesReporting = props => {
  const [callsData, setCallsData] = useState([])

  useEffect(() => {
    //console.log("Group calls data changed: " + JSON.stringify(props.data))
    setCallsData(props.data)
  }, [props.data])

  return (
    <>
      <Row>
        <Col>
          <div className="mt-2 mb-1">
            <Row>
              <ChartLicenses data={callsData} quickGuide={props.quickGuide} />
            </Row>
            <Row>
              <TableGroupLicenses
                minRows={0}
                selectedType={props.selectedType}
                data={callsData}
              />
            </Row>
          </div>
        </Col>
      </Row>
    </>
  )
}

GroupVideoLicensesReporting.propTypes = {
  data: PropTypes.any,
  selectedType: PropTypes.any,
  quickGuide: PropTypes.any,
}

export default withTranslation()(GroupVideoLicensesReporting)
